var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as statsAction from '../actions/stats.action';
import * as hoursAction from '../actions/hours.action';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { StatisticsService } from '../../statistics.service';
var StatsEffects = /** @class */ (function () {
    function StatsEffects(actions, statisticsService) {
        var _this = this;
        this.actions = actions;
        this.statisticsService = statisticsService;
        this.fetchStats = this.actions.ofType(statsAction.GET_STATS)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.statisticsService.fetchStats(body)
                .map(function (res) { return new statsAction.GetStatsSuccess(res); })
                .catch(function (error) { return of(new statsAction.GetStatsError(error)); });
        }));
        this.fetchHours = this.actions.ofType(hoursAction.GET_HOURS)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.statisticsService.fetchHours(body)
                .map(function (res) { return new hoursAction.GetHoursSuccess(res); })
                .catch(function (error) { return of(new hoursAction.GetHoursError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], StatsEffects.prototype, "fetchStats", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], StatsEffects.prototype, "fetchHours", void 0);
    return StatsEffects;
}());
export { StatsEffects };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/effects/stats.effect.ts.pre-build-optimizer.js